import toastService from "Root/profile/toastService";
import { apiGetCommunicationPrefs, apiGetUserAccount } from "Root/api/apiProfile";
import { setAccountLoadingAction, setUserAccountAction, setOriginalUserAccountDataAction, setCommunicationPrefsAction, } from "Root/profile/redux/actionCreators/makeActionCreator";
export const fetchUserAccountThunk = () => async (dispatch) => {
    try {
        const data = await apiGetUserAccount();
        dispatch(setUserAccountAction(data));
        dispatch(setOriginalUserAccountDataAction(data));
    }
    catch (e) {
        toastService.errorMessage("Something went wrong");
    }
    finally {
        dispatch(setAccountLoadingAction(false));
    }
};
export const fetchCommunicationPrefsThunk = () => async (dispatch) => {
    try {
        const data = await apiGetCommunicationPrefs();
        dispatch(setCommunicationPrefsAction(data));
    }
    catch (e) {
        toastService.errorMessage("Something went wrong");
    }
};
